import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import Logo from "./Logo";
import { CONTACT_EMAIL, LINKEDIN_URL, WHATSAPP_URL } from "../config";

const linkCls =
    "font-mono text-[11px] uppercase tracking-[0.2em] text-[#888888] transition-colors duration-300 hover:text-gold";

export default function Footer() {
    const [privacyOpen, setPrivacyOpen] = useState(false);

    return (
        <footer className="border-t border-line bg-[#0a0a0a] px-6 py-14 lg:px-10" data-testid="site-footer">
            <div className="mx-auto flex max-w-7xl flex-col gap-10 md:flex-row md:items-end md:justify-between">
                <div>
                    <Logo onClick={() => window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.2 }) : window.scrollTo({ top: 0, behavior: "smooth" })} />
                    <p
                        className="mt-7 max-w-xs font-mono text-[11px] leading-relaxed text-[#666666]"
                        data-testid="footer-copyright"
                    >
                        MasterClaus © 2026. Investigação Comercial. Todos os direitos
                        reservados.
                    </p>
                </div>
                <div className="md:text-right">
                    <p className="text-sm text-[#e6e6e6]" data-testid="footer-contact">
                        Claudio Gabriel <span className="text-gold">|</span>{" "}
                        <span className="text-[#888888]">Analista de Inteligência Comercial</span>
                    </p>
                    <nav className="mt-6 flex flex-wrap gap-7 md:justify-end">
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={linkCls}
                            data-testid="footer-link-whatsapp"
                        >
                            WhatsApp
                        </a>
                        <a
                            href={LINKEDIN_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={linkCls}
                            data-testid="footer-link-linkedin"
                        >
                            LinkedIn
                        </a>
                        <a
                            href={`mailto:${CONTACT_EMAIL}`}
                            className={linkCls}
                            data-testid="footer-link-email"
                        >
                            {CONTACT_EMAIL}
                        </a>
                        <button onClick={() => setPrivacyOpen(true)} className={linkCls} data-testid="footer-link-privacidade">
                            Política de Privacidade
                        </button>
                    </nav>
                </div>
            </div>

            <Dialog open={privacyOpen} onOpenChange={setPrivacyOpen}>
                <DialogContent className="border-gold-faint bg-[#141414] sm:max-w-md" data-testid="privacy-dialog">
                    <DialogHeader>
                        <DialogTitle className="font-serif text-xl text-white">
                            Política de Privacidade
                        </DialogTitle>
                        <DialogDescription className="text-sm leading-relaxed text-[#9a9a9a]">
                            O MasterClaus utiliza as informações enviadas voluntariamente pelo
                            formulário (nome, empresa, WhatsApp e segmento) exclusivamente para
                            elaborar o seu Esboço Investigativo e entrar em contato. Seus dados
                            não são vendidos nem compartilhados com terceiros. Você pode
                            solicitar a exclusão dos seus dados a qualquer momento.
                        </DialogDescription>
                    </DialogHeader>
                </DialogContent>
            </Dialog>
        </footer>
    );
}
